import * as React from "react";
const SvgContentful = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1773EB",
  d: "M9.025 3.001c.844.843 1.167 2.079.844 3.228a6.65 6.65 0 0 1 3.441-.953h.025a6.7 6.7 0 0 1 4.74 1.988 2.636 2.636 0 0 0 3.727.093 2.64 2.64 0 0 0 .015-3.808A11.94 11.94 0 0 0 13.351 0h-.046A11.9 11.9 0 0 0 6.62 2.036h.074a3.28 3.28 0 0 1 2.331.967z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E44F20",
  d: "M19.897 15.999c-.695 0-1.364.275-1.857.765a6.7 6.7 0 0 1-4.727 1.952h-.025a6.64 6.64 0 0 1-3.444-.968c.08.287.118.584.118.882 0 1.823-1.475 3.3-3.297 3.3H6.58A11.9 11.9 0 0 0 13.27 24h.046c3.164.005 6.2-1.249 8.441-3.484a2.641 2.641 0 0 0-1.857-4.514V16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFDA00",
  d: "M4.33 16.295a3.27 3.27 0 0 1 2.332-.967q.455 0 .893.122a6.7 6.7 0 0 1 .013-6.928 3.297 3.297 0 0 1-4.171-3.187v-.09a12.01 12.01 0 0 0-.032 13.452v-.069a3.27 3.27 0 0 1 .965-2.333"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1773EB",
  d: "M6.694 2.62c-.75 0-1.275.312-1.911.949-.606.605-.797 1.135-.799 1.766a2.71 2.71 0 1 0 5.42-.004 2.71 2.71 0 0 0-2.71-2.71"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E44F20",
  d: "M3.945 18.632c0 .748.311 1.275.946 1.91.606.607 1.134.8 1.764.802a2.7 2.7 0 0 0 2.693-2.712 2.702 2.702 0 0 0-5.403.008z"
}));
export default SvgContentful;
//# sourceMappingURL=Contentful.js.map